export const evaluateStatsmodelsTags = Object.freeze([
    "roe",
    "optimization",
    "simplified_optimization"
]);
